// extracted by mini-css-extract-plugin
export default {"divider":"coTBfAxsHWCe42eLV_Wk"};